import { useState } from 'react'
import { createMockSession, type MockAccountId } from '../api/auth'
import { ApiError } from '../api/client'

interface Props {
  onSuccess: () => void | Promise<void>
}

const ACCOUNTS: Array<{ id: MockAccountId; name: string; niche: string; initial: string }> = [
  { id: 'creator_a', name: '科技区UP主', niche: '知识 · 科技', initial: '科' },
  { id: 'creator_b', name: '游戏区UP主', niche: '游戏 · 二次元', initial: '游' },
  { id: 'creator_c', name: '生活区UP主', niche: '生活 · 泛娱乐', initial: '生' },
]

export function BilibiliLoginDialog({ onSuccess }: Props) {
  const [selected, setSelected] = useState<MockAccountId>('creator_a')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const login = async () => {
    setLoading(true)
    setError('')
    try {
      await createMockSession(selected)
      await onSuccess()
    } catch (reason) {
      setError(reason instanceof ApiError ? reason.message : '演示账号登录失败，请稍后重试')
    } finally {
      setLoading(false)
    }
  }

  return (
    <section className="login-card" aria-label="Biliup Mock 演示登录">
      <div className="login-mark">B</div>
      <span className="eyebrow">PUBLIC MOCK DEMO</span>
      <h1>进入 Biliup Demo</h1>
      <p>选择一个模拟 UP 主账号，查看投稿数据并打开创作工作区。</p>

      <div className="mock-demo-notice" role="note">
        <strong>Mock 演示模式</strong>
        <span>使用预置账号数据，登录后可以直接查看和编辑。</span>
      </div>

      <div className="mock-account-list" role="radiogroup" aria-label="选择演示账号">
        {ACCOUNTS.map(account => (
          <button
            key={account.id}
            type="button"
            className={`mock-account-card ${selected === account.id ? 'selected' : ''}`}
            role="radio"
            aria-checked={selected === account.id}
            onClick={() => setSelected(account.id)}
          >
            <span className="mock-account-avatar">{account.initial}</span>
            <span className="mock-account-copy"><strong>{account.name}</strong><small>{account.niche}</small></span>
            <span className="mock-account-check" aria-hidden="true"><i className="ri-check-line" /></span>
          </button>
        ))}
      </div>

      {error && <div className="inline-notice" role="alert">{error}</div>}
      <button className="btn btn-wide btn-primary" type="button" onClick={() => void login()} disabled={loading}>
        {loading ? '正在进入演示…' : '进入 Mock 演示'} <span>→</span>
      </button>
      <a className="login-real-demo-link" href="https://demo.biliup.laniakea777.cloud/" target="_blank" rel="noreferrer">
        体验登录版 Demo <span aria-hidden="true">↗</span>
      </a>
      <small className="login-note">演示数据可在页面右上角重置；登录凭证由服务端 HttpOnly Cookie 保存。</small>
    </section>
  )
}
